/**
 * Legacy entry point for auth helpers. The implementation lives in
 * AuthService.ts — see documentation/auth-architecture.md.
 *
 * Tokens are fetched on demand and never cached in app state; most callers
 * should not need this at all, because the axios request interceptor attaches
 * the Authorization header for MuseFlow API requests automatically.
 */
import { authService } from './AuthService';

export const getCurrentAuthToken = (): Promise<string | undefined> => authService.getToken();
